var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContactSales = function SvgIconContactSales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#IconContactSales_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 7.498A8.008 8.008 0 1 0 8.01 16h4.655A3.337 3.337 0 0 0 16 12.667zm-1.334 5.169a2 2 0 0 1-2 2H8.011a6.7 6.7 0 0 1-4.984-2.229 6.61 6.61 0 0 1-1.65-5.21 6.695 6.695 0 0 1 5.77-5.84q.432-.054.867-.055a6.6 6.6 0 0 1 4.252 1.534 6.7 6.7 0 0 1 2.4 4.694z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.334 6H8a.667.667 0 0 0 0-1.333H5.334a.667.667 0 1 0 0 1.333M10.667 7.333H5.334a.667.667 0 0 0 0 1.334h5.333a.667.667 0 1 0 0-1.334M10.667 10H5.334a.666.666 0 1 0 0 1.333h5.333a.667.667 0 1 0 0-1.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconContactSales_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h17v17H0z"
  })))));
};
export default SvgIconContactSales;